import {
  BannerFragment,
  BannerFragmentDoc,
  execute,
  GetBannersDocument,
  getFragmentData,
  GetBannersQuery
} from '@/fo/api/magento';
import { UiModFootnoteBase } from '@/fo/ui/mod/footnote/base';

export interface FeatureBannerDataBaseProps {
  ids?: string[];
  slug?: string;
  children: (data: BannerFragment[]) => React.ReactNode;
  customData?: GetBannersQuery['bannerEntities'];
}

/**
 * Компонент для получения баннеров из API
 * Использует UiModFootnoteBase для отображения сносок
 */
export async function FeatureBannerDataBase({
  children,
  customData,
  ids,
  slug
}: FeatureBannerDataBaseProps) {
  const response = customData
    ? {
        data: {
          bannerEntities: customData
        }
      }
    : await execute(GetBannersDocument, { ids, slug });

  if (
    !response.data ||
    !response.data.bannerEntities ||
    !response.data.bannerEntities.length
  ) {
    return null;
  }

  const banners = response.data?.bannerEntities
    .map((banner) => getFragmentData(BannerFragmentDoc, banner))
    .filter((banner) => banner !== null);

  const content = (
    <>
      {children(banners)}
      {banners
        .filter((banner) => banner.banner_data?.footnote)
        .map((banner) => (
          <UiModFootnoteBase
            key={banner.id}
            id={banner.id}
            text={banner.banner_data?.footnote || ''}
          />
        ))}
    </>
  );

  if (!slug) {
    return content;
  }

  return <div id={slug}>{content}</div>;
}
